import { render, staticRenderFns } from "./pb-po-item.vue?vue&type=template&id=7e412747"
import script from "./pb-po-item.vue?vue&type=script&lang=js"
export * from "./pb-po-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports